import React from 'react'
import { Typography, useTheme } from '@mui/material'
import { getStatusTimeline } from './get-status-timeline'
import { Connector, Content, Item, Separator } from './styles'
import TimelineContent from './timeline-content'
import type { TimelineItemProps } from './types'

const TimelineItem: React.FC<TimelineItemProps> = ({
  badgeProps,
  title,
  avatarData,
  isLast,
  status,
  content,
  reminder,
  isOffice,
  id,
}) => {
  const { palette } = useTheme()
  const Status = getStatusTimeline({ status })

  return (
    <Item data-testid="timeline-item">
      <Separator>
        <Status />
        {!isLast && <Connector data-testid="timeline-separator" />}
      </Separator>
      <Content>
        <Typography variant="body2" color={palette.text.secondary}>
          {title}
        </Typography>
        <TimelineContent
          badgeProps={badgeProps}
          isOffice={isOffice}
          title={title}
          avatarData={avatarData}
          content={content}
          reminder={reminder}
          id={id}
        />
      </Content>
    </Item>
  )
}

export default TimelineItem
